import { postFormData,deleteJson } from './baseApi'

export const createPicture = formData => {
	return postFormData('/api/pictures', formData, { timeout: 30000 })
}

export const deletePicture = (pictureId)  => {

	return deleteJson(`/api/pictures/${pictureId}`)
}